import { areObjectsDeeplyEqual } from '@vfde-sails/utils';
import { ProductContainerProps } from './';

/**
 * Helper function to help determine which part of the UI
 * needs to be updated based on state changes
 * @param {ProductContainerProps} props - new state
 * @param {ProductContainerProps} oldProps - old state
 * @returns {Object} - object containing booleans
 */
export const getUpdateFlags = ({ selected, availabilityResult, product, isGigakombi, customer }: ProductContainerProps, oldProps: ProductContainerProps) => {
    const optionChanged = selected.option !== oldProps.selected.option;
    const deviceChanged = selected.device !== oldProps.selected.device;
    const typeChanged = selected.type !== oldProps.selected.type;
    const selectedChanged = !areObjectsDeeplyEqual(selected, oldProps.selected);
    const availabilityChanged = !areObjectsDeeplyEqual(availabilityResult, oldProps.availabilityResult);
    const productsChanged = !areObjectsDeeplyEqual(product, oldProps.product);
    const customerChanged = !areObjectsDeeplyEqual(customer, oldProps.customer);

    return {
        productPiker: typeChanged || availabilityChanged,
        optionPicker: optionChanged,
        devicePicker: deviceChanged,
        benefits: typeChanged,
        promotionalCard: availabilityChanged || typeChanged,
        summaryCard: selectedChanged
            || availabilityChanged
            || productsChanged
            || customerChanged
            || isGigakombi !== oldProps.isGigakombi,
    };
};
